import React, { createContext, useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useRepairServiceApi } from 'services/providers/api/Api';
import { useAppState } from './AppState';
import { Notify } from '../../helpers/messages/Notify';

export const UserContext = createContext({
  username: undefined,
  isLogged: false,
});

export const useUser = () => useContext(UserContext);

const UserProvider = ({ children }) => {
  const [user, setUser] = useState({});
  const { jwtStore, setIsLoading } = useAppState();
  const token = jwtStore.getToken();
  const [isApiPartner, setIsApiPartner] = useState(true);
  const { getUserToken, forgotPassword, getRepairPartnerById } =
    useRepairServiceApi();
  const history = useHistory();
  useEffect(() => {
    getUserFromToken();
    setIsLoading(false);
  }, [token]);

  const login = async ({ email, password }, msg) => {
    try {
      const { data } = await getUserToken({
        credentials: {
          username: email,
          password,
        },
      });
      jwtStore.setToken(data.access_token);
      const userRoles = getUserFromToken();

      if (
        userRoles === 'ROLE_REPAIR_CENTER_AGENT' ||
        userRoles === 'ROLE_BACK_OFFICE'
      ) {
        history.push('/dashboard/workorders');
      } else if (
        userRoles === 'ROLE_LOGISTIC_PARTNER' ||
        userRoles === 'ROLE_LOGISTIC_CENTER_AGENT'
      ) {
        history.push('/dashboard/logistics');
      } else {
        history.push('/dashboard/repaircenters');
      }
    } catch (error) {
      Notify.error(msg('error'), msg('errorDesc'));
    }
  };

  const sendForgotPassword = async ({ email }, msg) => {
    try {
      await forgotPassword({
        email,
      });
      Notify.success(msg('success'));
    } catch (error) {
      if (error.response.status === 404) {
        Notify.error(msg('not_found'));
      } else {
        Notify.error(msg('error'));
      }
      throw error;
    }
  };

  const logout = callback => {
    setUser({ isLogged: false });
    jwtStore.removeToken();
    callback?.();
  };

  const getUserFromToken = () => {
    const credentials = jwtStore.getPayload();
    if (credentials) {
      setUser({
        ...credentials,
        userRoles: credentials.role,
        isLogged: true,
      });

      if (
        ['ROLE_REPAIR_CENTER_AGENT', 'ROLE_REPAIR_PARTNER'].includes(
          credentials.role,
        ) &&
        credentials.rpsId
      ) {
        getRepairPartnerById(credentials.rpsId)
          .then(res => setIsApiPartner(res.data?.is_api))
          .catch(err => Notify.error(err?.response?.data?.error?.message));
      } else {
        setIsApiPartner(false);
      }
      return credentials.role;
    } else {
      setUser({ isLogged: false });
    }
  };

  return (
    <UserContext.Provider
      value={{ user, login, logout, sendForgotPassword, isApiPartner }}
    >
      {children}
    </UserContext.Provider>
  );
};

export default UserProvider;
